import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RevertPlanReviewFindingMutationVariables = Types.Exact<{
  findingId: Types.Scalars['uuid']['input'];
}>;


export type RevertPlanReviewFindingMutation = { __typename?: 'mutation_root', revert_plan_review_finding: { __typename?: 'PlanReviewFindingChangeResult', finding_id: any, review_outcome: string } };


export const RevertPlanReviewFindingDocument = gql`
    mutation revertPlanReviewFinding($findingId: uuid!) {
  revert_plan_review_finding(finding_id: $findingId) {
    finding_id
    review_outcome
  }
}
    `;
export type RevertPlanReviewFindingMutationFn = Apollo.MutationFunction<RevertPlanReviewFindingMutation, RevertPlanReviewFindingMutationVariables>;

/**
 * __useRevertPlanReviewFindingMutation__
 *
 * To run a mutation, you first call `useRevertPlanReviewFindingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevertPlanReviewFindingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revertPlanReviewFindingMutation, { data, loading, error }] = useRevertPlanReviewFindingMutation({
 *   variables: {
 *      findingId: // value for 'findingId'
 *   },
 * });
 */
export function useRevertPlanReviewFindingMutation(baseOptions?: Apollo.MutationHookOptions<RevertPlanReviewFindingMutation, RevertPlanReviewFindingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevertPlanReviewFindingMutation, RevertPlanReviewFindingMutationVariables>(RevertPlanReviewFindingDocument, options);
      }
export type RevertPlanReviewFindingMutationHookResult = ReturnType<typeof useRevertPlanReviewFindingMutation>;
export type RevertPlanReviewFindingMutationResult = Apollo.MutationResult<RevertPlanReviewFindingMutation>;
export type RevertPlanReviewFindingMutationOptions = Apollo.BaseMutationOptions<RevertPlanReviewFindingMutation, RevertPlanReviewFindingMutationVariables>;